import React from "react";

interface NoTranslateProps {
  children: React.ReactNode;
}

export const NoTranslate: React.FC<NoTranslateProps> = ({ children }) => {
  return <span translate="no">{children}</span>;
};

export default NoTranslate;
